import type { Theme } from "@mui/material/styles";

/** Dark theme only: the dialog header takes the app bar fill. Light theme keeps the shared dialog header. */
export function darkDialogHeaderSx(theme: Theme) {
  if (theme.palette.mode !== "dark") return {};
  return { backgroundColor: theme.app.headerBackground } as const;
}

/** Dark theme only: the dialog body sits on the page surface instead of the lighter elevated paper. */
export function darkDialogContentSx(theme: Theme) {
  if (theme.palette.mode !== "dark") return {};
  return { backgroundColor: theme.palette.background.default } as const;
}
